import React, { useEffect, useState } from 'react'
import SingleStanding from './LeagueTemplates/SingleStanding'
import { getLeagueStandings } from '../../../../api/api_football'

function LeagueStandings(props) {

    const [standings, setStandings] = useState()
    const [isLoading, setIsLoading] = useState(true)

    const [type, setType] = useState("")

    useEffect(() => {

        async function getStandings() {

            setIsLoading(true)
            try {
                const data = await getLeagueStandings(props.id, props.season)
                if (data) {
                    setStandings(data)
                    console.log(data, "STANDINGS")
                    if (data?.length > 1) {
                        setType("groups")
                    } else {
                        setType("league")
                    }
                } else {
                    console.log("Could not fetch")
                }
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)
        }
        getStandings()

    }, [props.season])

    if (isLoading) return <p>Loading standings....</p>

    return (
        <div className="bg-white">
            {standings?.map((standing, index) => {
                return <SingleStanding key={index} standing={standing} type={type} index={index} />
            })}
        </div>
    )
}
export default LeagueStandings